import React from 'react'
import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'
import get from 'lodash/get'
import { CollapsingBlock, InjectHtml } from '@/components/ui'
import type { IConditionsTableProps } from '../interfaces'
import { messages } from '../messages'

const ConditionTableMobile: React.FC<IConditionsTableProps> = props => {
  const { conditionsTable = [], blockId, shouldMarkFirstRow, tableTitleId, className } = props
  const table = shouldMarkFirstRow ? conditionsTable.slice(1) : conditionsTable

  return (
    <section id={blockId} className={className || 'space-holder56-sm space-holder-top56-sm'}>
      {tableTitleId && (
        <h2 className="space-holder32-sm page-wrapper">
          <FormattedMessage id={tableTitleId} />
        </h2>
      )}

      {table.map(
        ({ captionId, values, isInnerHeading }) =>
          !isInnerHeading && (
            <CollapsingBlock
              headingClass="h4"
              titleId={get(messages.caption, captionId)}
              className="background_white space-holder4-sm landing-constructor-conditions-table-collapsing-block"
              key={captionId}
            >
              <div className="landing-constructor-conditions-table-row">
                {values.map(({ descriptions }, index) => (
                  <React.Fragment key={index}>
                    {descriptions.map(({ textId, titleId, mobileInnerHeadingId, noticeId }) => (
                      <React.Fragment key={textId || titleId}>
                        {titleId && (
                          <h5>
                            <FormattedMessage id={get(messages.title, titleId)} />
                          </h5>
                        )}

                        {mobileInnerHeadingId && (
                          <h5 className={classNames('color_green space-holder8', { 'space-holder-top16': index !== 0 })}>
                            <FormattedMessage id={get(messages.text, mobileInnerHeadingId)} />
                          </h5>
                        )}

                        {noticeId && (
                          <InjectHtml
                            textId={get(messages.text, noticeId)}
                            className="text_small space-holder16-sm landing-constructor-conditions-table-row__notice color_pale-black"
                          />
                        )}

                        {textId && (
                          <InjectHtml
                            textId={get(messages.text, textId)}
                            className="landing-constructor-conditions-table-row-description"
                          />
                        )}
                      </React.Fragment>
                    ))}
                  </React.Fragment>
                ))}
              </div>
            </CollapsingBlock>
          ),
      )}
    </section>
  )
}

export default ConditionTableMobile
